var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"img-zoom-content",style:(Object.assign({}, {'background-image': 'url(' + _vm.resolveImg + ')'},
    _vm.resolveWidth))},[_c('a',{attrs:{"target":"_blank","href":_vm.imageUrl}},[_c('icon-zoom-img',{staticClass:"w-100"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }